import styles from './progressRing.module.scss';

interface IProps {
  strokeColor: string,
  strokeDashoffset: number,
  normalizedRadius: number,
  radius: number,
  circumference: number,
  stroke: number,
}

const ItemRing = ({ strokeColor, strokeDashoffset, normalizedRadius, radius, circumference, stroke }: IProps) => (
  <svg
    height={ radius * 2 }
    width={ radius * 2 }
  >
    <circle
      className={ styles.circle }
      stroke={ strokeColor }
      fill="transparent"
      strokeWidth={ stroke }
      strokeDasharray={ `${ circumference } ${ circumference }` }
      style={ { strokeDashoffset } }
      r={ normalizedRadius }
      cx={ radius }
      cy={ radius }
    />
  </svg>
);

export default ItemRing;
